import { render, staticRenderFns } from "./ExpertCard.vue?vue&type=template&id=92688eb2&scoped=true"
import script from "./ExpertCard.vue?vue&type=script&lang=js"
export * from "./ExpertCard.vue?vue&type=script&lang=js"
import style0 from "./ExpertCard.vue?vue&type=style&index=0&id=92688eb2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92688eb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92688eb2')) {
      api.createRecord('92688eb2', component.options)
    } else {
      api.reload('92688eb2', component.options)
    }
    module.hot.accept("./ExpertCard.vue?vue&type=template&id=92688eb2&scoped=true", function () {
      api.rerender('92688eb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/ExpertCard.vue"
export default component.exports